import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { ICounty } from 'models/County'

export const GetCounties = action('GetCounties', payload<IPayload<ICounty[]>>())
export const UpdateCounty = action('UpdateCounty', payload<IPayload<ICounty>>())
export const GetCountiesErrors = action('GetCountiesErrors', payload<IError>())
export const CountiesFetching = action('CountiesFetching', payload<boolean>())
